/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BulkResult } from '../models/bulk-result';
import { createDevice } from '../fn/registered-device/create-device';
import { CreateDevice$Params } from '../fn/registered-device/create-device';
import { deleteDevice } from '../fn/registered-device/delete-device';
import { DeleteDevice$Params } from '../fn/registered-device/delete-device';
import { deleteDevicePlacement } from '../fn/registered-device/delete-device-placement';
import { DeleteDevicePlacement$Params } from '../fn/registered-device/delete-device-placement';
import { DeviceFullDto } from '../models/device-full-dto';
import { DeviceInUseDto } from '../models/device-in-use-dto';
import { disable } from '../fn/registered-device/disable';
import { Disable$Params } from '../fn/registered-device/disable';
import { DownlinkCommandStatusDto } from '../models/downlink-command-status-dto';
import { getDevice } from '../fn/registered-device/get-device';
import { GetDevice$Params } from '../fn/registered-device/get-device';
import { getDevicePageData } from '../fn/registered-device/get-device-page-data';
import { GetDevicePageData$Params } from '../fn/registered-device/get-device-page-data';
import { getDevicePageLocationData } from '../fn/registered-device/get-device-page-location-data';
import { GetDevicePageLocationData$Params } from '../fn/registered-device/get-device-page-location-data';
import { getDevicesByFarm } from '../fn/registered-device/get-devices-by-farm';
import { GetDevicesByFarm$Params } from '../fn/registered-device/get-devices-by-farm';
import { getDownlinkCommandStatus } from '../fn/registered-device/get-downlink-command-status';
import { GetDownlinkCommandStatus$Params } from '../fn/registered-device/get-downlink-command-status';
import { getGroupDevicesByFacilityId } from '../fn/registered-device/get-group-devices-by-facility-id';
import { GetGroupDevicesByFacilityId$Params } from '../fn/registered-device/get-group-devices-by-facility-id';
import { LocationDevice } from '../models/location-device';
import { markAsCalibrated } from '../fn/registered-device/mark-as-calibrated';
import { MarkAsCalibrated$Params } from '../fn/registered-device/mark-as-calibrated';
import { RegisteredDevice } from '../models/registered-device';
import { RegisteredDeviceResponse } from '../models/registered-device-response';
import { replaceDevice } from '../fn/registered-device/replace-device';
import { ReplaceDevice$Params } from '../fn/registered-device/replace-device';
import { sendDownlinkCommand } from '../fn/registered-device/send-downlink-command';
import { SendDownlinkCommand$Params } from '../fn/registered-device/send-downlink-command';
import { setDeviceCalibrationByPast } from '../fn/registered-device/set-device-calibration-by-past';
import { SetDeviceCalibrationByPast$Params } from '../fn/registered-device/set-device-calibration-by-past';
import { updateDevicePlacements } from '../fn/registered-device/update-device-placements';
import { UpdateDevicePlacements$Params } from '../fn/registered-device/update-device-placements';
import { updateRegDeviceBasicData } from '../fn/registered-device/update-reg-device-basic-data';
import { UpdateRegDeviceBasicData$Params } from '../fn/registered-device/update-reg-device-basic-data';
import { upload } from '../fn/registered-device/upload';
import { Upload$Params } from '../fn/registered-device/upload';

@Injectable({ providedIn: 'root' })
export class RegisteredDeviceService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDevice()` */
  static readonly GetDevicePath = '/api/regdevice';

  /**
   * Get Device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevice$Response(params?: GetDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDeviceResponse>>> {
    return getDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevice(params?: GetDevice$Params, context?: HttpContext): Observable<Array<RegisteredDeviceResponse>> {
    return this.getDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RegisteredDeviceResponse>>): Array<RegisteredDeviceResponse> => r.body)
    );
  }

  /** Path part for operation `createDevice()` */
  static readonly CreateDevicePath = '/api/regdevice';

  /**
   * Create Device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDevice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDevice$Response(params: CreateDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return createDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDevice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDevice(params: CreateDevice$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.createDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

  /** Path part for operation `sendDownlinkCommand()` */
  static readonly SendDownlinkCommandPath = '/api/regdevice/dlcommand';

  /**
   * Send Downlink Command.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendDownlinkCommand()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDownlinkCommand$Response(params: SendDownlinkCommand$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendDownlinkCommand(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Downlink Command.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendDownlinkCommand$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDownlinkCommand(params: SendDownlinkCommand$Params, context?: HttpContext): Observable<void> {
    return this.sendDownlinkCommand$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDownlinkCommandStatus()` */
  static readonly GetDownlinkCommandStatusPath = '/api/regdevice/dlcommand/{identifier}';

  /**
   * Get Downlink Command Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDownlinkCommandStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDownlinkCommandStatus$Response(params: GetDownlinkCommandStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<DownlinkCommandStatusDto>> {
    return getDownlinkCommandStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Downlink Command Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDownlinkCommandStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDownlinkCommandStatus(params: GetDownlinkCommandStatus$Params, context?: HttpContext): Observable<DownlinkCommandStatusDto> {
    return this.getDownlinkCommandStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<DownlinkCommandStatusDto>): DownlinkCommandStatusDto => r.body)
    );
  }

  /** Path part for operation `getGroupDevicesByFacilityId()` */
  static readonly GetGroupDevicesByFacilityIdPath = '/api/regdevice/facility/{facilityId}';

  /**
   * Get Group Devices By Facility Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupDevicesByFacilityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupDevicesByFacilityId$Response(params: GetGroupDevicesByFacilityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceInUseDto>>> {
    return getGroupDevicesByFacilityId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Group Devices By Facility Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroupDevicesByFacilityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupDevicesByFacilityId(params: GetGroupDevicesByFacilityId$Params, context?: HttpContext): Observable<Array<DeviceInUseDto>> {
    return this.getGroupDevicesByFacilityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceInUseDto>>): Array<DeviceInUseDto> => r.body)
    );
  }

  /** Path part for operation `getDevicesByFarm()` */
  static readonly GetDevicesByFarmPath = '/api/regdevice/facilityZoneId/{facilityZoneId}';

  /**
   * Get Devices By Farm.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicesByFarm()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesByFarm$Response(params: GetDevicesByFarm$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDevice>>> {
    return getDevicesByFarm(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Devices By Farm.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicesByFarm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesByFarm(params: GetDevicesByFarm$Params, context?: HttpContext): Observable<Array<RegisteredDevice>> {
    return this.getDevicesByFarm$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RegisteredDevice>>): Array<RegisteredDevice> => r.body)
    );
  }

  /** Path part for operation `getDevicePageData()` */
  static readonly GetDevicePageDataPath = '/api/regdevice/full';

  /**
   * Get Device Page Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicePageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicePageData$Response(params?: GetDevicePageData$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceFullDto>> {
    return getDevicePageData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device Page Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicePageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicePageData(params?: GetDevicePageData$Params, context?: HttpContext): Observable<DeviceFullDto> {
    return this.getDevicePageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceFullDto>): DeviceFullDto => r.body)
    );
  }

  /** Path part for operation `getDevicePageLocationData()` */
  static readonly GetDevicePageLocationDataPath = '/api/regdevice/full/location';

  /**
   * Get Device Page Location Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicePageLocationData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicePageLocationData$Response(params?: GetDevicePageLocationData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationDevice>>> {
    return getDevicePageLocationData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device Page Location Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicePageLocationData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicePageLocationData(params?: GetDevicePageLocationData$Params, context?: HttpContext): Observable<Array<LocationDevice>> {
    return this.getDevicePageLocationData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LocationDevice>>): Array<LocationDevice> => r.body)
    );
  }

  /** Path part for operation `updateDevicePlacements()` */
  static readonly UpdateDevicePlacementsPath = '/api/regdevice/placement';

  /**
   * Update Device Placements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDevicePlacements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDevicePlacements$Response(params: UpdateDevicePlacements$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDevice>>> {
    return updateDevicePlacements(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Device Placements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDevicePlacements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDevicePlacements(params: UpdateDevicePlacements$Params, context?: HttpContext): Observable<Array<RegisteredDevice>> {
    return this.updateDevicePlacements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RegisteredDevice>>): Array<RegisteredDevice> => r.body)
    );
  }

  /** Path part for operation `deleteDevicePlacement()` */
  static readonly DeleteDevicePlacementPath = '/api/regdevice/placement';

  /**
   * Delete Device Placement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDevicePlacement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDevicePlacement$Response(params: DeleteDevicePlacement$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDeviceResponse>> {
    return deleteDevicePlacement(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Device Placement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDevicePlacement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDevicePlacement(params: DeleteDevicePlacement$Params, context?: HttpContext): Observable<RegisteredDeviceResponse> {
    return this.deleteDevicePlacement$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDeviceResponse>): RegisteredDeviceResponse => r.body)
    );
  }

  /** Path part for operation `replaceDevice()` */
  static readonly ReplaceDevicePath = '/api/regdevice/replace/{deviceId}';

  /**
   * Replace Device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceDevice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceDevice$Response(params: ReplaceDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return replaceDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Replace Device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `replaceDevice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceDevice(params: ReplaceDevice$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.replaceDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

  /** Path part for operation `upload()` */
  static readonly UploadPath = '/api/regdevice/upload';

  /**
   * Upload.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload$Response(params: Upload$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkResult>> {
    return upload(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload(params: Upload$Params, context?: HttpContext): Observable<BulkResult> {
    return this.upload$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkResult>): BulkResult => r.body)
    );
  }

  /** Path part for operation `updateRegDeviceBasicData()` */
  static readonly UpdateRegDeviceBasicDataPath = '/api/regdevice/{deviceId}';

  /**
   * Update Reg Device Basic Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRegDeviceBasicData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRegDeviceBasicData$Response(params: UpdateRegDeviceBasicData$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return updateRegDeviceBasicData(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Reg Device Basic Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRegDeviceBasicData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRegDeviceBasicData(params: UpdateRegDeviceBasicData$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.updateRegDeviceBasicData$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

  /** Path part for operation `deleteDevice()` */
  static readonly DeleteDevicePath = '/api/regdevice/{deviceId}';

  /**
   * Delete Device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDevice$Response(params: DeleteDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return deleteDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDevice(params: DeleteDevice$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.deleteDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

  /** Path part for operation `setDeviceCalibrationByPast()` */
  static readonly SetDeviceCalibrationByPastPath = '/api/regdevice/{deviceId}/calibration/bytime';

  /**
   * Set Device Calibration By Past.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setDeviceCalibrationByPast()` instead.
   *
   * This method doesn't expect any request body.
   */
  setDeviceCalibrationByPast$Response(params: SetDeviceCalibrationByPast$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return setDeviceCalibrationByPast(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Device Calibration By Past.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setDeviceCalibrationByPast$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setDeviceCalibrationByPast(params: SetDeviceCalibrationByPast$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.setDeviceCalibrationByPast$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

  /** Path part for operation `disable()` */
  static readonly DisablePath = '/api/regdevice/{deviceId}/disable/{disabled}';

  /**
   * Disable.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disable()` instead.
   *
   * This method doesn't expect any request body.
   */
  disable$Response(params: Disable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return disable(this.http, this.rootUrl, params, context);
  }

  /**
   * Disable.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disable(params: Disable$Params, context?: HttpContext): Observable<void> {
    return this.disable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markAsCalibrated()` */
  static readonly MarkAsCalibratedPath = '/api/regdevice/{deviceId}/markascalibrated';

  /**
   * Mark As Calibrated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAsCalibrated()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsCalibrated$Response(params: MarkAsCalibrated$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
    return markAsCalibrated(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark As Calibrated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAsCalibrated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsCalibrated(params: MarkAsCalibrated$Params, context?: HttpContext): Observable<RegisteredDevice> {
    return this.markAsCalibrated$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegisteredDevice>): RegisteredDevice => r.body)
    );
  }

}
